import {
    TYPE_COXA_TREATMENT_PERIOD,
    TYPE_DEFAULT,
    TYPE_FIMLAB,
    TYPE_HEARING_DEVICE_FIXING, TYPE_HEARING_DEVICE_MODELING, TYPE_SLEEP_CLINIC,
    TYPE_VIDEO_CONFERENCE
} from "../../../../../../definitions/TimelineItems";
import {TimelineFrameContentFimlabDetails} from "./TimelineFrameContentFimlabDetails";
import TimelineFrameContentVideoConference from "./TimelineFrameContentVideoConference";
import {TimelineFrameContentDefaultDetails} from "./TimelineFrameContentDefaultDetails";
import {useContext} from "react";
import {TimelineFrameDataContext} from "../../../../TimelineFramePage";
import {isPhoneVisit} from "../../../../../../utils/TimelineUtils";


export const TimelineFrameContentDetails = () => {
    const { data, genericPhrases } = useContext(TimelineFrameDataContext);

    const getDetailsViewBasedOnType = () => {
        switch(data.type) {
            case TYPE_FIMLAB:
                return <TimelineFrameContentFimlabDetails />;
            case TYPE_VIDEO_CONFERENCE:
                return <TimelineFrameContentVideoConference />; // TODO: Check "Tarkemmat tiedot" UI for Video Conference impl
            default:
                return <TimelineFrameContentDefaultDetails data={data} genericPhrases={genericPhrases} />;
        }
    }

    return getDetailsViewBasedOnType();
}